import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

const FloatingFAQ = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollY(currentScrollY);
      
      // Afficher le bouton après 200px de scroll
      if (currentScrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <Link
      to="/faq"
      className="fixed bottom-6 right-6 z-50 group"
      title="FAQ / Besoin d'aide ?"
      style={{
        transform: `translateY(${Math.sin(scrollY * 0.002) * 2}px)`,
        transition: 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
      }}
    >
      <div className="w-14 h-14 bg-primary text-primary-foreground rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 hover:-translate-y-1 flex items-center justify-center border border-primary/20 backdrop-blur-sm">
        <HelpCircle className="h-6 w-6" />
      </div>
    </Link>
  );
};

export default FloatingFAQ;